export enum ApplicationStatus {
  Incomplete = 'Incomplete',
  Eligible = 'Eligible',
  Ineligible = 'Ineligible'
}

export const APPLICATION_STATUS_OPTIONS = Object.values(ApplicationStatus).map((value) => ({ label: value, value }));
